import styled from "styled-components";

export default styled.div`
  font-family: "Chivo", sans-serif;
  font-size: 16px;
  @media (max-width: 960px) {
    font-size: 14px;
  }
  font-weight: 400;
`;
